import { QUERY_KEYS } from '@/constants'
import { useApiClient } from '@/hooks'
import { ApiErrorData, APIErrorResponse, ProjectSpecieBasic } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'

export const usePostProjectSpecieType = (
  projectId: number
): UseMutationResult<
  ProjectSpecieBasic,
  APIErrorResponse<ApiErrorData>,
  Omit<ProjectSpecieBasic, 'id'>
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (params) =>
      client
        .post<ProjectSpecieBasic>(`/projects/${projectId}/species/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: () => {
        const queryKey = QUERY_KEYS.RESEARCH_SPECIES.map((key) =>
          key === ':id' ? projectId.toString() : key
        )

        queryClient.removeQueries(queryKey)
      },
    }
  )
}
